import React, { useState, useEffect } from 'react';
import { Container, Button } from 'reactstrap';
import Sidebar from './components/Sidebar';
import Dashboard from './components/Dashboard';
import EntityList from './components/EntityList';

const AdminPage = () => {
    document.title = "Avaza Empleo | Admin";
    const [currentView, setCurrentView] = useState('dashboard');
    const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

    const renderContent = () => {
        switch (currentView) {
            case 'candidatos':
            return <EntityList title="Candidatos" type="candidato" isMobile={isMobile} />;
            case 'empresas':
            return <EntityList title="Empresas" type="empresa" isMobile={isMobile} />;
            case 'ofertas':
            return <EntityList title="Ofertas de Trabajo" type="oferta" isMobile={isMobile} />;
            case 'usuarios':
            return <EntityList title="Usuarios" type="usuario" isMobile={isMobile} />;
            default:
            return <Dashboard />;
        }
    };

  return (
    <div className="admin-wrapper d-flex min-vh-100 bg-light">
      {isMobile && (
          <Button
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
              className="position-fixed d-flex align-items-center justify-content-center shadow-lg border-0"
              style={{
                  bottom: '20px',
                  left: '20px',
                  width: '56px',
                  height: '56px',
                  borderRadius: '50%',
                  zIndex: 1001,
                  background: 'black',
              }}
          >
              <span className="h3 mb-0 text-white">☰</span>
          </Button>
      )}
      <Sidebar currentView={currentView} onViewChange={setCurrentView} isSidebarOpen={isSidebarOpen} />

      <div className="flex-grow-1" style={{ marginTop: '120px' }}>
        <main className="px-4 pb-5" style={{ marginLeft: window.innerWidth > 768 ? '280px' : '0' }}>
          <Container fluid="xl">
            {renderContent()}
          </Container>
        </main>
      </div>
    </div>
  );
};

export default AdminPage;